export interface BankIDSession {
  message: string;
  uuid: string;
  status?: BankIDStatus;
  auto_start_token?: string;
  qr_data?: string;
}

export enum BankIDStatus {
  PENDING = 'pending',
  FAILED = 'failed',
  COMPLETE = 'complete',
}

export interface BankIDLegalText {
  key: string;
  text: string;
}
